import React from 'react';
import { Link } from 'react-router-dom';
import { urlify } from '../../utils/string';
import s from './FormattedLink.scss';

const FormattedLink = ({ item, eventHandler, internal = false }) => {
	if (item.URL) {
		return <a className={item.classes ? item.classes.map(c => s[c]).join(' ') : null} href={item.URL} target="_blank">{ item.classes ? null : item.name }</a>;
	} else if (item.URI) {
		if (eventHandler) {
			if (internal) {
				return <Link to={`/${item.URI}`} onClick={eventHandler}>{ item.name }</Link>;
			}
			return <a href={`/${item.URI}`} onClick={eventHandler}>{ item.name }</a>;
		}
		return <Link to={`/${item.URI}`}>{ item.name }</Link>;
	}
	return <a href={`#${urlify(item)}`} onClick={eventHandler}>{item}</a>;
};

export default FormattedLink;



// WEBPACK FOOTER //
// ./components/Parts/FormattedLink.jsx